export default __webpack_public_path__ + "static/document-data-53ec951ea2fa5089266fea995cb2d086.png";